import { GoogleGenerativeAI } from "@google/generative-ai";
import { GEMINI_API_KEY } from '../config';
import { db } from '../firebase-config';
import { collection, getDocs } from 'firebase/firestore';

const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);

export const generateClientMessage = async (offerData) => {
  let contactEmail = 'info@nejirazukic.com';
  let contactPhone = '+387 62 123 456';

  try {
    const snap = await getDocs(collection(db, 'settings'));
    if (!snap.empty) {
      const s = snap.docs[0].data();
      if (s.email) contactEmail = s.email;
      if (s.phone) contactPhone = s.phone;
    }
  } catch (err) {
    console.warn('Could not fetch settings for contact info, using defaults.', err);
  }

  try {
    const model = genAI.getGenerativeModel({ model: "gemini-1.5-flash" });

    const prompt = `Kreiraj profesionalnu poruku na bosanskom jeziku za klijenta ${offerData.name} koji je zainteresovan za vjenčanje.

Podaci o ponudi:
- Ime klijenta: ${offerData.name}
- Datum vjenčanja: ${offerData.datum}
- Paket: ${offerData.nazivPaketa}
- Cijena: ${offerData.cijena} ${offerData.valuta}
- Link za pregled ponude: https://nejirazukic-weddings.web.app/client/${offerData.id}

Poruka treba biti:
1. Topla i profesionalna
2. Sadržati pozdrav sa imenom klijenta
3. Ukratko opisati ponudu
4. Sadržati link za pregled ponude
5. Pozvati klijenta da pregleda i prihvati/odbije ponudu
6. Završiti sa kontakt informacijama (email: ${contactEmail}, telefon: ${contactPhone})

Vrati samo tekst poruke, bez dodatnih objašnjenja.`;

    const result = await model.generateContent(prompt);
    const response = await result.response;
    return response.text().trim();
  } catch (error) {
    console.error('Error generating client message:', error);
    return `Poštovani ${offerData.name},

Pripremili smo personalizovanu ponudu za vaše vjenčanje zakazano za ${offerData.datum}.

Paket: ${offerData.nazivPaketa}
Cijena: ${offerData.cijena} ${offerData.valuta}

Molimo vas da pregledate detalje ponude i prihvatite ili odbijete istu klikom na link ispod:
https://nejirazukic-weddings.web.app/client/${offerData.id}

Za sva pitanja stojimo vam na raspolaganju.

S poštovanjem,
Nejira Zukić
Profesionalni fotograf i videograf vjenčanja
📧 ${contactEmail}
📱 ${contactPhone}`;
  }
};

export const generateSeoData = async (settings) => {
  try {
    const model = genAI.getGenerativeModel({ 
      model: "gemini-1.5-flash",
      generationConfig: {
        temperature: 0.2,
      },
    });

    const prompt = `Na osnovu sljedećih informacija o biznisu, generiši SEO (Search Engine Optimization) podatke za web stranicu profesionalne fotografkinje Nejire Zukić.

Informacije:
- Ime: Nejira Zukić
- Lokacija: ${settings.address || 'Sarajevo, BiH'}
- Usluge: Profesionalna fotografija i videografija vjenčanja
- Kontakt: ${settings.email || ''}, ${settings.phone || ''}
- Story/O meni: ${settings.storyPara1Bs || ''}

Trebam 3 polja u JSON formatu:
1. "title": Naslov stranice (do 60 karaktera, treba biti privlačan i sadržavati ključne riječi)
2. "description": Meta opis (do 160 karaktera, sažetak onoga što biznis nudi)
3. "keywords": Ključne riječi (odvojene zarezom)

Vrati ISKLJUČIVO čist JSON objekat, bez ikakvih markdown oznaka (poput \`\`\`json), bez dodatnog teksta ili objašnjenja.`;

    const result = await model.generateContent(prompt);
    const response = await result.response;
    const text = response.text();
    
    const cleanJson = text.replace(/```json|```/g, '').trim();
    return JSON.parse(cleanJson);
  } catch (error) {
    console.error('Gemini SEO error:', error);
    return null;
  }
};
